import { Component, Input, OnChanges } from '@angular/core'

import { Agrupamento } from '../../../pkw-data/collect/extrato/agrupamento.model'
import { Recebimento } from '../../../pkw-data/collect/extrato/recebimento.model'

@Component({
  selector: 'col-detalhe-recebimentos-estabelecimentos',
  templateUrl: './detalhe-recebimentos-estabelecimentos.component.html',
  styleUrls: ['../../extratos.component.scss']
})
export class DetalheRecebimentosEstabelecimentosComponent implements OnChanges {

  @Input() agrupamento: Agrupamento<Recebimento>

  maisDetalhesExpandido: boolean[]

  constructor() {}

  ngOnChanges() {
      if (this.agrupamento) {
          this.maisDetalhesExpandido = new Array(this.agrupamento.detalhes.length)
          this.maisDetalhesExpandido.fill(false)
      }
  }

  toggleCollapse(index: number, icon: HTMLSpanElement) {
      this.maisDetalhesExpandido[index] = !this.maisDetalhesExpandido[index]

      icon.classList.toggle('fa-chevron-right')
      icon.classList.toggle('fa-chevron-down')
  }

}



// WEBPACK FOOTER //
// ./src/app/extratos/extratos-de-recebimentos/detalhe-recebimentos-estabelecimentos/detalhe-recebimentos-estabelecimentos.component.ts